<template>
  <CDropdown
    :toggler-text="orderOption"
    placement="right-start"
    addTogglerClasses="customDropDownColor"
  >
    <CDropdownItem @click="orderOption = 'Highest'">Highest</CDropdownItem>
    <CDropdownItem @click="orderOption = 'Lowest'">Lowest</CDropdownItem>
  </CDropdown>
</template>

<script>
export default {
  name: "amountOrder",
  data() {
    return {
      orderOption: "Highest"
    };
  }
};
</script>
